import React from "react";
import { Skeleton, SkeletonCircle, SkeletonBar } from "../../utils/skeleton/Skeleton";

const StatCardSkeleton = () => (
  <div className="col-sm-12 col-md-6 col-xl-3">
    <div className="card custom-card">
      <div className="card-body">
        <Skeleton w="55%" h={12} />
        <div className="d-flex align-items-start justify-content-between" style={{ marginTop: 10 }}>
          <div style={{ flex: 1, paddingRight: 10 }}>
            <Skeleton w="70%" h={24} />
            <div style={{ marginTop: 10 }}>
              <SkeletonBar />
            </div>
            <div style={{ marginTop: 8 }}>
              <Skeleton w="35%" h={12} />
            </div>
          </div>
          <div className="avatar avatar-md bg-light">
            <div className="d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
              <SkeletonCircle size={22} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const StatCard = ({
  title,
  value,
  subtitle,
  iconClass = "fa fa-chart-line",
  textClass = "text-primary",
  loading = false,
}) => {
  if (loading) return <StatCardSkeleton />;

  return (
    <div className="col-sm-12 col-md-6 col-xl-3">
      <div className="card custom-card">
        <div className="card-body">
          <div className="d-flex align-items-start justify-content-between">
            <div>
              <p className="tx-12 text-muted mb-1">{title}</p>
              <h4 className="tx-20 mb-0">{value}</h4>
              {subtitle ? <small className="text-muted">{subtitle}</small> : null}
            </div>
            <div className={`avatar avatar-md bg-light ${textClass}`}>
              <i className={iconClass}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
